import React from "react";
import styled from "styled-components";
import Meter from "../../../assets/img/icons/Article/Meter.svg";

function CMSPill(props) {
  return (
    <ContentEngagementStyle textSize={props.textSize}>
      <div className="cms-pill-wrapper">
        <span className="">My CMS</span>
      </div>
    </ContentEngagementStyle>
  );
}

export default CMSPill;

const ContentEngagementStyle = styled.div`
  .cms-pill-wrapper {
    display: flex;
    background-color: #fff;
    color: #7e7e7e;
    padding: 0px 10px;
    font-size: ${(props) => (props.textSize ? props.textSize : "14px")};
    border-radius: 12px;
    font-family: "robotomedium", sans-serif;
    box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 40%);
  }
`;
